import './styles/index.css';
import { TaskWrapper } from './components/TaskWrapper';
import { Footer } from './components/Footer';

function App() {
  return (
    <div className="App">
      <TaskWrapper />
      <Footer />
    </div>
  );
}

export default App;
